import { LayoutThree } from '../../Layout/CommonStyle'
import RecentJobs from '../../Common/RecentJobs'
import TestList from '../../Common/TestList'
import { useState } from 'react'
import JobSearch from '../../Common/JobSearch'

function MentorSearch() {
  return (
    <LayoutThree>
      <JobSearch />
      <TestList />
      <RecentJobs />
    </LayoutThree>
  )
}

export default MentorSearch
